<template>
  <div class="tut-taget-item">
    <div class="sample">
      <div class="">
        <MicOffIcon />
      </div>
      <div class="dot"></div>
    </div>
    <span>{{ t('mic_off') }}</span>
  </div>
</template>
<script setup lang="ts">
import MicOffIcon from '@/components/icons/IconMicOff.vue';

const { t } = useI18n();
</script>

<style scoped lang="scss">
.tut-taget-item {
  background: var(--surface-overlay);
  border: 2px solid $color-navy-50;
  border-radius: $size-s;
  width: auto;
  max-width: 100px;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  text-align: center;
  white-space: nowrap;

  .sample {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    height: 3rem;
    gap: $size-s;
    svg {
      fill: $color-gray-60;
    }
    .dot {
      width: 0.5rem;
      height: 0.5rem;
      background: $color-gray-60;
      border-radius: 50%;
    }
  }
  span {
    font-size: $font-size-psmall;
    font-weight: 500;
    color: $color-gray-200;
  }
}
</style>
